import type { AddVersionChoice } from 'components/documentation/AddVersionDialog';
import type { DocumentationModel } from 'shared/domain/documentation/documentationModel';
import type { ExportedVersionOptions } from 'shared/domain/issue/linkedDocumentation/operations';
import { removeFileExtension } from 'shared/utils/fileExtensions';

/** What the export reads of a file of the issue to name it: a gallery file has both. */
interface ExportedFile {
  title?: string;
  data?: { name?: string };
}

export function getExportedFileName(file: ExportedFile): string {
  return file.data?.name || file.title || '';
}

/** The name the backend gives an exported version (D10): the file's name without its extension. */
export function getDefaultVersionName(file: ExportedFile): string {
  return removeFileExtension(getExportedFileName(file));
}

/** Withdrawn versions keep their position, so the next number follows all of them. */
export function getNextVersionNumber(documentation: DocumentationModel): number {
  return documentation.versions.length + 1;
}

/** What the user chose in the dialog that adds the file as a version. */
export type ExportedVersionChoice = AddVersionChoice;

/** The name goes to the backend only when the user changed it: otherwise the backend's own is kept. */
export function toExportedVersionOptions(
  { name, makeCurrent }: ExportedVersionChoice,
  defaultName: string
): ExportedVersionOptions {
  const trimmedName = name.trim();
  return {
    makeCurrent,
    ...(trimmedName && trimmedName !== defaultName ? { name: trimmedName } : {}),
  };
}
